import { createSlice } from '@reduxjs/toolkit';
import { addClub } from '../club/clubSlice';

const initialState = {
  clubId: null,
  isSettingsComplete: false,
  // incompleteSettingsCount: 0,
  settingsId: [],
  settingsActiveId: [],
  selectedSports: [],
  moving: true,
  otherSettings: [],
};

const settingsSlice = createSlice({
  name: 'settings',
  initialState,
  reducers: {
    resetSettings() {
      return initialState;
    },
    setSettingsComplete(state, action) {
      state.isSettingsComplete = action.payload;
    },
    setIncompleteSettingsCount(state, action) {
      state.incompleteSettingsCount = action.payload;
    },
    movingSetting(state, action) {
      state.moving = action.payload;
    },

    addSettingId(state, action) {
      const id = action.payload;
      if (!state.settingsId.includes(id)) {
        state.settingsId.push(id);
      }
    },
    addOtherSettings(state, action) {
      const id = action.payload;
      if (!state.otherSettings.includes(id)) {
        state.otherSettings.push(id);
      }
    },
    addSettingsActiveId(state, action) {
      const id = action.payload;
      if (!state.settingsActiveId.includes(id)) {
        state.settingsActiveId.push(id);
      }
    },

    updateSelectedSports(state, action) {
      const newSports = action.payload;

      state.selectedSports = newSports;

      const filterFn = (item) =>
        typeof item === 'number' || newSports.includes(item);

      state.settingsActiveId = (state.settingsActiveId || []).filter(filterFn);
      state.settingsId = (state.settingsId || []).filter(filterFn);

      state.otherSettings = (state.otherSettings || []).filter(filterFn);
    },
  },
  extraReducers: (builder) => {
    builder.addCase(addClub, (state, action) => {
      const newClubId = action.payload?.id ?? null;
      if (newClubId !== null && newClubId !== state.clubId) {
        return { ...initialState, clubId: newClubId };
      }
    });
  },
});

export const {
  resetSettings,
  setSettingsComplete,
  setIncompleteSettingsCount,
  addSettingId,
  addSettingsActiveId,
  updateSelectedSports,
  movingSetting,
  addOtherSettings,
} = settingsSlice.actions;

export default settingsSlice.reducer;
